export type CandidateProgramFlags = {
  isOliveProgram: boolean;
  isOliveVistaProgram: boolean;
  isOliveFamily: boolean;
  isMistProgram: boolean;
  isFistProgram: boolean;
  isDshProgram: boolean;
  isOdrProgram: boolean;
  isCovidProgram: boolean;
  isCovidTestingProgram: boolean;
  isCovidVaccineProgram: boolean;
  isInfluenzaVaccineProgram: boolean;
  isMonkeypoxVaccineProgram: boolean;
  isCovidVaccineFamily: boolean;
  isMaternalProgram: boolean;
  isInrepProgram: boolean;
  isProgressReportProgram: boolean;
  isLeadProgram: boolean;
  isLaiProgram: boolean;
  isLaiCommunityProgram: boolean;
  isChargesManagerProgram: boolean;
  canOpenParticipantShortcut: boolean;
};

export const getCandidateProgramFlags = (programKey: string): CandidateProgramFlags => {
  const isOliveProgram = programKey === 'olive';
  const isOliveVistaProgram = programKey === 'olive-vista';
  const isMistProgram = programKey === 'mist';
  const isFistProgram = programKey === 'fist';
  const isDshProgram = programKey === 'dsh';
  const isOdrProgram = programKey === 'odr';
  const isCovidProgram = programKey === 'covid';
  const isCovidTestingProgram = programKey === 'covid-testing';
  const isCovidVaccineProgram = programKey === 'covid-vaccine';
  const isInfluenzaVaccineProgram = programKey === 'influenza-vaccine';
  const isMonkeypoxVaccineProgram = programKey === 'monkeypox-vaccine';
  const isMaternalProgram = programKey === 'maternal';
  const isInrepProgram = programKey === 'inrep';
  const isProgressReportProgram = programKey === 'progress-report';
  const isLeadProgram = programKey === 'lead';
  const isLaiProgram = programKey === 'lai';
  const isLaiCommunityProgram = programKey === 'lai-community';
  const isChargesManagerProgram = programKey === 'charges-manager';

  const isOliveFamily = isOliveProgram || isOliveVistaProgram;
  const isCovidVaccineFamily = isCovidVaccineProgram || isMonkeypoxVaccineProgram;
  const canOpenParticipantShortcut =
    isOdrProgram || isFistProgram || isMistProgram || isLeadProgram || isMaternalProgram;

  return {
    isOliveProgram,
    isOliveVistaProgram,
    isOliveFamily,
    isMistProgram,
    isFistProgram,
    isDshProgram,
    isOdrProgram,
    isCovidProgram,
    isCovidTestingProgram,
    isCovidVaccineProgram,
    isInfluenzaVaccineProgram,
    isMonkeypoxVaccineProgram,
    isCovidVaccineFamily,
    isMaternalProgram,
    isInrepProgram,
    isProgressReportProgram,
    isLeadProgram,
    isLaiProgram,
    isLaiCommunityProgram,
    isChargesManagerProgram,
    canOpenParticipantShortcut,
  };
};
